/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import styled from 'styled-components'
import TextAtomic from '../../atomic/Text'

const StyledText = styled(TextAtomic)`
  color: ${({ color }: { color: string }) =>
    color ? `var(${color})` : '#616161'};
  font-size: var(--app-subheader-fontsize-s2, --typography-size-s2);
`

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TextLogic = ({
  Wrapper,
  text,
  color,
}: {
  Wrapper: any
  text: string
  color: string
}) => {
  return <Wrapper text={text} color={color} />
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Text = (props: any) => <TextLogic Wrapper={StyledText} {...props} />

export default Text
